import React from "react";
import { Link } from "react-router-dom";

import logo from "../../assets/landing/vendstash-nav-logo.svg";

/** Shared marketing footer used across the landing and content pages. */
const Footer: React.FC = () => {
  return (
    <footer className='site-footer' id='contact'>
      <div className='site-footer__brand'>
        <Link aria-label='VendStash home' className='site-footer__logo' to='/'>
          <img alt='VendStash' width={112} height={23} src={logo} />
        </Link>
        <p>
          VendStash helps buyers and vendors complete online transactions with
          protected payments, clear delivery steps, and fair release rules.
        </p>
      </div>
      <div aria-label='Footer navigation' className='site-footer__links'>
        <nav aria-label='Product'>
          <h2>Product</h2>
          <ul>
            <li>
              <a href='/#how-it-works'>How it works</a>
            </li>
            <li>
              <Link to='/for-buyers'>Buyers</Link>
            </li>
            <li>
              <Link to='/for-vendors'>Vendors</Link>
            </li>
            <li>
              <a href='/#security'>Security</a>
            </li>
          </ul>
        </nav>
        <nav aria-label='Company'>
          <h2>Company</h2>
          <ul>
            <li>
              <Link to='/about'>About us</Link>
            </li>
            <li>
              <Link to='/contact'>Contact</Link>
            </li>
          </ul>
        </nav>
        <nav aria-label='Resources'>
          <h2>Resources</h2>
          <ul>
            <li>
              <Link to='/faq'>FAQs</Link>
            </li>
            <li>
              <Link to='/terms'>Terms of Service</Link>
            </li>
            <li>
              <Link to='/privacy-policy'>Privacy Policy</Link>
            </li>
          </ul>
        </nav>
        <nav aria-label='Socials'>
          <h2>Socials</h2>
          <ul>
            <li>
              <a
                href='https://instagram.com/vendstash_'
                target='_blank'
                rel='noreferrer'>
                Instagram
              </a>
            </li>
            <li>
              <a
                href='https://twitter.com/vendstash'
                target='_blank'
                rel='noreferrer'>
                X
              </a>
            </li>
            <li>
              <a
                href='https://www.linkedin.com/company/vendstash/'
                target='_blank'
                rel='noreferrer'>
                LinkedIn
              </a>
            </li>
            <li>
              <a
                href='https://web.facebook.com/61554099410029/'
                target='_blank'
                rel='noreferrer'>
                Facebook
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <div className='site-footer__legal'>
        <p>
          © {new Date().getFullYear()} VendStash. A product of Mitochron Hub.
        </p>
      </div>
      <p className='site-footer__disclaimer'>
        VendStash provides technology-supported escrow workflows for protected
        transactions. VendStash is not a bank; funds are held and processed
        through regulated financial partners where applicable.
      </p>
    </footer>
  );
};

export default Footer;
